<template>
    <div class="mt-3">
         
         <emc-table-items 
            :headers="headers" 
            v-bind:params.sync="params"
            v-bind:collections.sync="collections"
            v-bind:meta.sync="meta"
            v-bind:itemDelete.sync="itemDelete" 
            v-bind:itemEdit.sync="model"
            :find="false"
            :loadingText="loadingText"
        >
        
            <template v-slot:item.company="{ item }">
                <span v-if="item.company"><br/>{{ item.company.name }}</span>
                <small v-if="item.branch"><br/>{{ item.branch.name }}</small>
            </template>

        </emc-table-items>

        <sys-register-teacher-contract @onCompleted="getData()" :teacher="teacher" :model="model" v-bind:show.sync="showForm" />

    <!-- Modal usado para mensagem e ação de exclusão -->
        <emc-alert-modal :text="textDelete" :disabled="deleting" v-bind:show.sync="show">
            <template v-slot:actions>
                <v-btn color="error" @click.prevent.stop="deleteItem()" :loading="deleting" :disabled="deleting">Excluir <v-icon right dark>mdi-delete</v-icon></v-btn>
            </template>
        </emc-alert-modal>
        
        <!-- Alert para mensagens -->
        <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
    
    </div>

</template>
<script>

import { mapActions } from 'vuex'

export default {
   name: 'SysTeacherContract',
   data: () => ({
    collections: [],
    loadingText: '',
    params: {},
    message: '',
    error: false,
    errors: {},
    loading: false,
    meta: {},
    itemDelete: {},
    model: {},
    itemUpdate: {},
    show: false,
    showForm: false,
    text: 'Carregando dados...',
    textDelete: '',
    deleting: false,
    headers: [
        { text: 'Empresa', value: 'company', sortable: false },
        { text: 'Cargo', value: 'position.name', sortable: false },
        { text: 'Vínculo', value: 'relationship', sortable: false, type: 'initials' },
        { text: 'Valor Hora', value: 'hour_value', type: 'money', sortable: false },
        { text: 'Nível de Curso', value: 'courseLevels', type: 'array', sortable: false },
        { text: 'Modalidade', value: 'courseModalities', type: 'array', sortable: false },
        { text: 'Admissão/Desligamento', value: ['date_admission', 'date_resignation'], range: true, type: 'date', align: 'center' },
        { text: 'Status', value: 'active', type: 'boolean', sortable: false},
        { text: 'Ações', value: 'actions', sortable: false}
    ]
    }),

    props: {
        
        teacher: {
            required: true
        },
        
        showAdd: {
            type: Boolean,
            default: false
        }
    },

    watch: {
      
      //Função para tratar quando um item for exibido para deletar
      itemDelete(item_new, item_old){
          
          if(item_new !== item_old && Object.keys(item_new).length > 0)
          {
              this.show = true;
              this.textDelete = "Deseja excluir o item?";
          } else {
              this.show = false
              this.textDelete = '';
          }
      },
      

      showAdd(val){
          if(val){
            this.model = {};
            this.showForm = true;
          }
          
      },

      showForm(val){
          if(!val){
                this.$emit('update:showAdd', val);
          }
      },

      model(item_new, item_old){
          
        if(item_new !== item_old && this.teacher && this.teacher.id)
          {
              this.showForm = true;
              this.errors = {};
          } else if(Object.keys(this.model).length === 0){
              this.showForm = false;
              this.errors = {};
          }           
      },

    },
    components: {
      
    },

    mounted(){
       
    },
    created() {
         if(this.teacher && this.teacher.id){
            this.getData();
         }
    },
    methods: {
      ...mapActions('teacherContract', ['ActionFindTeacherContracts', 'ActionDeleteTeacherContract']),
        
    getData(){
        
        this.error = false;
        this.message = '';
        this.showForm = false;
        this.loadingText = 'Carregando dados...';
        this.collections = [];

        const params = this.params;

        params.with = 'teacher,campuses,courses,company,branch,position,courseLevels,relationship,courseModalities';
        params.find_columns = {
            teacher_id: this.teacher.id
        };

        this.ActionFindTeacherContracts(params)
            .then((res) => {
                this.collections = res.data;
                this.meta = res.meta;
            })
            .finally(() => {
                this.loadingText = '';
            });
    },

    deleteItem()
        {
            this.deleting = true;
            this.message = '';

            this.ActionDeleteTeacherContract({ id: this.itemDelete.id })
                .then((res) => {
                    this.message = res.message;
                    this.show = false;
                    this.getData(res.data);
                })
                .catch((error) =>{
                  this.message = error.message;
                  this.error = true;
                })
                .finally(() => {
                    this.deleting = false;
                });
        }

  },

}
</script>
